import { MaskLine, Eyebrow } from "./motion";
import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, lines, intro, testId }) => (
  <section data-testid={testId} className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-32 sm:pt-40 pb-12 sm:pb-20">
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>
      <Eyebrow>{eyebrow}</Eyebrow>
    </motion.div>
    <h1 className="mt-5 font-wide uppercase leading-[0.9] text-[13vw] sm:text-[9vw] lg:text-[7.2vw] 2xl:text-[104px]">
      {lines.map((l, i) => (
        <MaskLine key={i} i={i} className={i === lines.length - 1 ? "text-dano-red" : ""}>{l}</MaskLine>
      ))}
    </h1>
    {intro && (
      <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.8 }} className="mt-8 max-w-2xl text-base sm:text-lg text-dano-ink/80 leading-relaxed">
        {intro}
      </motion.p>
    )}
  </section>
);
